import Vue from 'vue'
import Vuex from 'vuex'
import pageButton from './modules/pageButton'
import home2other from './modules/home2other'
import bannerManage from './modules/bannerManage'
import user from './modules/user'
import getters from './getters'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    pageButton,
    user,
    home2other,
    bannerManage
  },
  state: {
    tenantName: ''
  },
  mutations: {
    setTenantName: (state, tenantName) => {
      state.tenantName = tenantName
    },
  },
  getters,
  plugins: [createPersistedState({
    reducer(state) {
      return {
        bannerManage: state.bannerManage
      }
    }
  })]
})
export default store




// WEBPACK FOOTER //
// ./src/store/index.js